import { Form, Formik } from "formik";
import React from "react";
import { useHistory } from "react-router-dom";

import { logInUser, signInWithGoogle } from "../../auth/authImplementation";
import AddSpacing from "../../components/AddSpacing";

import Authentication from "./Authentication";
import {
  AuthInputRow,
  AuthTitle,
  error,
  GoogleSignInButton,
  Line,
  RedirectLink,
  SignInButton,
} from "./SharedComponent";

const LoginPage = () => {
  const history = useHistory();

  const submit = async (object) => {
    const { email, password } = object;
    try {
      await logInUser(email, password);
      history.push("/");
    } catch (e) {
      error(e.message);
    }
  };

  const GoogleLogIn = async () => {
    try {
      await signInWithGoogle();
      history.push("/");
    } catch (e) {
      error(e.message);
    }
  };

  return (
    <Authentication>
      <AuthTitle>Sign-in to Copysmith</AuthTitle>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <GoogleSignInButton onClick={GoogleLogIn} />
      </div>
      <Line />
      <Formik
        initialValues={{ email: "", password: "", accessCode: "" }}
        onSubmit={submit}
      >
        {({ handleChange, handleBlur, handleSubmit }) => (
          <Form>
            <AddSpacing spacing={20}>
              <AuthInputRow
                types="email"
                titles="Email Address"
                propObjects={{
                  name: "email",
                  onChange: handleChange,
                  onBlur: handleBlur,
                }}
              />
              <AuthInputRow
                types="password"
                titles="Password"
                propObjects={{
                  name: "password",
                  onChange: handleChange,
                  onBlur: handleBlur,
                }}
              />
              {/* <CheckboxObject/> */}
              <SignInButton type="submit" onSubmit={handleSubmit}>
                Sign In
              </SignInButton>
            </AddSpacing>
          </Form>
        )}
      </Formik>
      <RedirectLink link="/signup" name="Need an account?" linkName="Sign Up" />
    </Authentication>
  );
};

export default LoginPage;
